import moment from 'moment';

/**
 * Returns a human-readable duration string from now until the given expiry date.
 * e.g. "2 years, 3 months, 5 days from today" or "Expired" or "Today".
 */
export function getExpiryDuration(expiryDate: Date): string {
	const now = moment();
	const expiry = moment(expiryDate);
	if (expiry.isBefore(now)) return 'Expired';
	const years = expiry.diff(now, 'years');
	const afterYears = now.clone().add(years, 'years');
	const months = expiry.diff(afterYears, 'months');
	const afterMonths = afterYears.clone().add(months, 'months');
	const days = expiry.diff(afterMonths, 'days');

	const parts: string[] = [];
	if (years > 0) parts.push(`${years} year${years !== 1 ? 's' : ''}`);
	if (months > 0) parts.push(`${months} month${months !== 1 ? 's' : ''}`);
	if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
	return parts.length > 0 ? `${parts.join(', ')} from today` : 'Today';
}
